import { Col, Row } from 'antd';
import cn from 'classnames';

import { API, I18nt } from 'utils';
import Container from 'components/Container';
import { Categories } from './Categories';

import styles from './Faq.module.less';
import { Link } from 'react-router-dom';
import { paths } from 'config';
import BannerWithImage from 'components/BannerWithImage';
import { useEffect, useState } from 'react';
import { ICategory } from 'utils/interfaces';

interface Props {
  className?: string;
  children: JSX.Element | JSX.Element[];
}

function Wrapper({ className, children }: Props) {
  return (
    <Container className={className}>
      <Row>
        <Col xs={24} sm={24} md={24} lg={18} xl={18} xxl={18}>
          {children}
        </Col>
      </Row>
    </Container>
  );
}

function Contact() {
  const [faqs, setFaqs] = useState<ICategory[]>([]);

  const goTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    API.getFaqs().then((response: { data: ICategory[] }) => {
      setFaqs(response.data);
    });
  }, []);

  return (
    <section className={styles.section}>
      <BannerWithImage>
        <Wrapper className={styles.headerContainer}>
          <h2>{I18nt('resuelve_tus_dudas')}</h2>
          <div className={styles.flexCont}>
            <h4 className='text-align-center'>
              {I18nt('preguntas_frecuentes')}
            </h4>
          </div>
          <p>{I18nt('descripcion_preguntas')}</p>
        </Wrapper>
        <Container className={styles.faqContainer}>
          <Row>
            <Col xs={24} lg={16} className={'container-white'}>
              <Categories data={faqs} />
            </Col>
          </Row>
        </Container>
        <Container
          className={cn(
            styles.suggestionsCont,
            'container-white pt-16 pb-16 mb-32'
          )}
        >
          <Row>
            <Col xs={24} md={16}>
              <div className={styles.addSuggestions}>
                <h4>{I18nt('sugerir_preguntas')}</h4>
                <Link
                  className={styles.hereLink}
                  to={paths.contact}
                  state={I18nt('sugerencia')}
                >
                  {I18nt('dejar_sugerencia')}
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col xs={24} md={16}>
              <div className={styles.goBackCont} onClick={goTop}>
                <svg
                  className={styles.goBackIcon}
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 384 512'
                >
                  <path d='M352 352c-8.188 0-16.38-3.125-22.62-9.375L192 205.3l-137.4 137.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25C368.4 348.9 360.2 352 352 352z' />
                </svg>
                <div>{I18nt('back_to_top')}</div>
              </div>
            </Col>
          </Row>
        </Container>
      </BannerWithImage>
    </section>
  );
}

export default Contact;
